import { useState, useEffect } from 'react';
import { BrowserRouter } from 'react-router-dom';
import { AppRoutes } from './router';
import { AchievementNotification } from './components/feature/AchievementNotification';
import { useAchievements } from './hooks/useAchievements';
import { feistyPets } from './mocks/feistyPets';
import { AuthProvider } from './contexts/AuthContext';

function App() {
  const totalCount = feistyPets.length;
  const { newlyUnlocked, dismissAchievement, checkForNewAchievements } = useAchievements(0, totalCount);
  const [processedEvents, setProcessedEvents] = useState<Set<string>>(new Set());

  useEffect(() => {
    const handleAchievementCheck = (event: CustomEvent) => {
      const { previousCount, currentCount } = event.detail;
      
      // Cria um ID único para este evento baseado nos valores e timestamp
      const eventId = `${previousCount}-${currentCount}`;
      
      // Verifica se já processamos este evento recentemente (dentro de 1 segundo)
      if (processedEvents.has(eventId)) {
        return;
      }
      
      // Marca como processado
      setProcessedEvents(prev => new Set(prev).add(eventId));
      
      // Processa as conquistas
      checkForNewAchievements(previousCount, currentCount);
      
      // Limpa eventos antigos após 2 segundos
      setTimeout(() => {
        setProcessedEvents(prev => {
          const newSet = new Set(prev);
          newSet.delete(eventId);
          return newSet;
        });
      }, 2000);
    };

    window.addEventListener('achievementCheck', handleAchievementCheck as EventListener);

    return () => {
      window.removeEventListener('achievementCheck', handleAchievementCheck as EventListener);
    };
  }, [checkForNewAchievements, processedEvents]);

  return (
    <BrowserRouter basename={__BASE_PATH__}>
      <AuthProvider>
        <AppRoutes />
        
        {/* Notificações de Conquistas - Apenas uma por vez */}
        {newlyUnlocked.length > 0 && (
          <AchievementNotification
            achievement={newlyUnlocked[0]}
            onDismiss={dismissAchievement}
          />
        )}
      </AuthProvider>
    </BrowserRouter>
  );
}

export default App;
